import axios from "axios";
import {Message} from "element-ui";

axios.defaults.withCredentials = true;
//import service from "./serviceConfig";
//let APIkey = service.apikey();
const HttpError = {
  400: "请求错误",
  401: "未授权，请登录",
  403: "拒绝访问",
  404: "求地址出错",
  408: "请求超时",
  500: "服务器开个小差，请稍后再试",
  501: "服务器开个小差，请稍后再试",
  502: "服务器开个小差，请稍后再试",
  503: "服务器开个小差，请稍后再试",
  504: "服务器开个小差，请稍后再试",
  505: "HTTP版本不受支持"
};

axios.interceptors.request.use(
  config => {
    if (window.location.host.indexOf('localhost') > -1) { // 本地测试添加用户信息
      // config.headers.common['X-ER-User-Info'] = "a2FuZ2ppYW5kb25n"//a2FuZ2ppYW5kb25n
      // config.headers.common['X-ER-User-Name'] = "a2FuZ2ppYW5kb25n"
      // config.headers.common['X-ER-User-Real-Name'] = "a2FuZ2ppYW5kb25n"
      // d3V5b3U3 非管理员人
      // bGl1bGlmYW5n 刘立方
      // config.headers.common['X-ER-User-Info'] = "cmVueWk="
      // config.headers.common['X-ER-User-Name'] = "cmVueWk="
      // config.headers.common['X-ER-User-Real-Name'] = "5Lu75q+F"
      // config.headers.common['X-ER-User-Info'] = "bGl1bGlmYW5n"
      // config.headers.common['X-ER-User-Name'] = "bGl1bGlmYW5n"
      // config.headers.common['X-ER-User-Real-Name'] = "5YiY56uL5pa5"
    }
    config.headers.common['Content-Type'] = "application/json;charset=UTF-8"
    config.headers.common['X-Gaia-Api-Key'] = "46d096f0-2912-48c3-9733-7246f2690166"
    // config.headers.common['X-Gaia-Api-Key'] = "APIkey"
    config.headers.common['X-ER-System-Info'] = "default"
    config.headers.common['Accept-Language'] = "zh-CN"
    config.crossDomain = true;
    config.timeout = 1200000;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 拦截响应response，并做一些错误处理
axios.interceptors.response.use(
  res => {
    try {
      // TODO: set response pre-judge-handler
    } catch (e) {
      console.info(
        `错误名称: ${e.name}\n错误描述: ${e.message}\n错误堆栈: ${e.stack}`
      );
    }
    return res;
  },

  err => {
    if (err && err.response && err.response.status == "401") {
      let url = err.response.data.loginUrl;
      let localUrl = escape(escape("#/" + location.href.split("/#/")[1]));
      setTimeout(() => {
        window.location.href = url + localUrl;
      }, 200);
    }
    // let msg =
    //   err.toString().indexOf("timeout") != -1
    //     ? "请求超时，请稍后再试"
    //     : "请求错误";
    // console.log(msg);
    // err && err.response && (msg = HttpError[err.response.status]);
    if (err && err.response && err.response.status) {
      err.message = HttpError[err.response.status]
    }
    return Promise.reject(err);
  }
);
/**
 * @func axios的二次封装
 * @param method-请求方法，url-接口地址，data-请求参数
 */
const request = (url, data = {}, method = "GET", style = '') => {
  // ;
  let params, paramsData;
  if (method.toUpperCase() === "GET") {
    params = "params";
    paramsData = Object.assign({}, data, {'dateTime2': new Date().getTime()})
  } else {
    params = "data";
    paramsData = data
  }
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: method,
      [params]: paramsData,
      responseType: style
    })
      .then(res => {
        resolve(res);
      })
      .catch(e => {
        if (e && e.response && e.response.status == "500") {
          let response = JSON.parse(JSON.stringify(e.response));
          let message = response.data && response.data.message;
          if (message) {
            Message.error(message);
            console.log(response.config.url.split(':'));
            let url = response.config.url.split(':').length > 2 ? response.config.url.split(':')[2].split('/').splice(1) : ''
            if (url && url.join('/') == "bpm-portal-server/api/old-work-orders/actions/check") {
              reject(e);
            } else if (url && url.join('/') == "bpm-portal-server/api/old-work-orders/actions/import") {
              reject(e);
            } else {
              return false;
            }
          } else {
            reject(response.data);
          }
        } else {
          reject(e);
        }
      });
  });
};

export default request;



// WEBPACK FOOTER //
// ./src/api/request.js